let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h4Smg")).then(() => parcelRequire('kk210'));